import { createContext } from "react";

//form error

//form info
export interface IWebsiteManagerFormContext {
  mode: "Edit" | "Add" | "Info";
}
export const WebsiteManagerFormContext = createContext<IWebsiteManagerFormContext | null>(null);
